/*
  Collection card sliders: image arrows and the colour swatch slider.
  Loaded by sections/main-collection.liquid when "Enable image arrows and
  swatch slider" is on. Markup lives in snippets/product-grid-item.liquid and
  snippets/product-card-swatches.liquid.

  Each card ships its image list as JSON. Only the featured image is in the
  page; the rest of its colour set is built into the slide track once the card
  nears the viewport, and each image's src is only filled in when it is next
  to the one on show. Choosing a swatch rebuilds the track with that colour's
  set, starting on the variant's own image.

  Everything is delegated from document, so cards re-rendered by AJAX
  filtering keep working; collection:reloaded re-runs the viewport observer.
*/
(function() {
  if (window.productCardSliders) {
    return;
  }
  window.productCardSliders = true;

  var widths = [360, 540, 720, 900];
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollBehavior() {
    return reduceMotion.matches ? 'auto' : 'smooth';
  }

  function imageUrl(src, width) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function cardImages(gallery) {
    if (!gallery._cardImages) {
      try {
        gallery._cardImages = JSON.parse(gallery.querySelector('[data-card-images]').textContent);
      } catch (e) {
        gallery._cardImages = [];
      }
    }
    return gallery._cardImages;
  }

  // Images for a colour set. Products without set tags in their alt text
  // show every image whatever colour is chosen.
  function setImages(gallery, set) {
    var images = cardImages(gallery);
    if (gallery.dataset.hasSets !== 'true') {
      return images;
    }
    return images.filter(function(image) {
      return image.set === set;
    });
  }

  function slideCache(gallery) {
    if (!gallery._slides) {
      gallery._slides = {};
      gallery.querySelectorAll('.grid-product__slide').forEach(function(slide) {
        gallery._slides[slide.dataset.mediaId] = slide;
      });
      var featured = gallery.querySelector('.grid-product__slide img');
      gallery._sizes = (featured && featured.getAttribute('sizes')) || '(min-width: 769px) 40vw, 100vw';
    }
    return gallery._slides;
  }

  function createSlide(gallery, image) {
    var slide = document.createElement('div');
    slide.className = 'grid-product__slide';
    slide.dataset.mediaId = image.id;

    var img = document.createElement('img');
    img.alt = image.alt;
    img.decoding = 'async';
    img.sizes = gallery._sizes;
    img.dataset.src = imageUrl(image.src, 720);
    img.dataset.srcset = widths.map(function(width) {
      return imageUrl(image.src, width) + ' ' + width + 'w';
    }).join(', ');

    slide.appendChild(img);
    return slide;
  }

  function track(gallery) {
    return gallery.querySelector('[data-card-slides]');
  }

  function slideCount(gallery) {
    return track(gallery).children.length;
  }

  function currentIndex(gallery) {
    var slides = track(gallery);
    var width = slides.getBoundingClientRect().width;
    return width ? Math.round(slides.scrollLeft / width) : 0;
  }

  // Cards are often a fractional number of pixels wide while scroll positions
  // round to whole pixels, so a sliver of the neighbouring image can show.
  // Measure each slide rather than multiplying, and once scrolling stops hide
  // every slide but the one on show.
  function slideOffset(slides, index) {
    var slide = slides.children[index];
    return slides.scrollLeft + slide.getBoundingClientRect().left - slides.getBoundingClientRect().left;
  }

  // Fill in the src of the slide on show and its neighbours (wrapping).
  function loadAround(gallery, index) {
    var slides = track(gallery).children;
    var count = slides.length;
    [index - 1, index, index + 1].forEach(function(i) {
      var img = slides[(i + count) % count].querySelector('img[data-srcset]');
      if (img) {
        img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
      }
    });
  }

  function settle(gallery) {
    var slides = track(gallery);
    var index = currentIndex(gallery);
    Array.prototype.forEach.call(slides.children, function(slide, i) {
      slide.classList.toggle('is-current', i === index);
    });
    slides.classList.add('is-settled');
  }

  // Touch screens get dots under the image instead of arrows. Past maxDots
  // they'd be too small to read, so long image lists show a "3 / 24" count.
  var maxDots = 8;

  function renderDots(gallery) {
    var dots = gallery.querySelector('[data-card-dots]');
    if (!dots) {
      return;
    }

    var count = slideCount(gallery);
    var fragment = document.createDocumentFragment();
    if (count > maxDots) {
      var counter = document.createElement('span');
      counter.className = 'grid-product__dots-count';
      fragment.appendChild(counter);
    } else {
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('span');
        dot.className = 'grid-product__dot';
        fragment.appendChild(dot);
      }
    }
    dots.replaceChildren(fragment);
    gallery._dotIndex = -1;
    updateDots(gallery);
  }

  function updateDots(gallery) {
    var dots = gallery.querySelector('[data-card-dots]');
    var index = currentIndex(gallery);
    if (!dots || index === gallery._dotIndex) {
      return;
    }
    gallery._dotIndex = index;

    var counter = dots.querySelector('.grid-product__dots-count');
    if (counter) {
      counter.textContent = (index + 1) + ' / ' + slideCount(gallery);
      return;
    }
    Array.prototype.forEach.call(dots.children, function(dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function build(gallery, set, mediaId) {
    var images = setImages(gallery, set);
    if (!images.length) {
      return;
    }

    var cache = slideCache(gallery);
    var fragment = document.createDocumentFragment();
    var index = 0;

    images.forEach(function(image, i) {
      var id = String(image.id);
      cache[id] = cache[id] || createSlide(gallery, image);
      fragment.appendChild(cache[id]);
      if (id === String(mediaId)) {
        index = i;
      }
    });

    var slides = track(gallery);
    slides.replaceChildren(fragment);
    slides.scrollLeft = slideOffset(slides, index);

    gallery.dataset.set = set;
    gallery._built = true;
    gallery.classList.toggle('grid-product__media--single', images.length < 2);
    settle(gallery);
    renderDots(gallery);
  }

  function ensureBuilt(gallery) {
    if (!gallery._built) {
      var featured = gallery.querySelector('.grid-product__slide');
      build(gallery, gallery.dataset.set, featured ? featured.dataset.mediaId : null);
    }
  }

  function go(gallery, step) {
    ensureBuilt(gallery);
    var count = slideCount(gallery);
    if (count < 2) {
      return;
    }

    var next = (currentIndex(gallery) + step + count) % count;
    var slides = track(gallery);
    loadAround(gallery, next);
    slides.scrollTo({ left: slideOffset(slides, next), behavior: scrollBehavior() });
  }

  function selectSwatch(swatch) {
    var card = swatch.closest('.grid-product');
    if (!card) {
      return;
    }

    card.querySelectorAll('[data-card-swatch]').forEach(function(other) {
      other.setAttribute('aria-pressed', other === swatch ? 'true' : 'false');
    });

    card.querySelectorAll('[data-card-link]').forEach(function(link) {
      link.setAttribute('href', swatch.dataset.url);
    });

    var gallery = card.querySelector('[data-card-gallery]');
    if (gallery) {
      gallery._restore = null;
      build(gallery, swatch.dataset.set, swatch.dataset.mediaId);
      loadAround(gallery, currentIndex(gallery));
    }
  }

  // Hovering a swatch shows that colour's image until the pointer leaves,
  // as the theme's own collection swatches do. Clicking keeps it.
  function previewSwatch(swatch) {
    var card = swatch.closest('.grid-product');
    var gallery = card && card.querySelector('[data-card-gallery]');
    if (!gallery) {
      return;
    }

    if (!gallery._restore) {
      var current = track(gallery).children[currentIndex(gallery)];
      gallery._restore = {
        set: gallery.dataset.set,
        mediaId: current ? current.dataset.mediaId : null
      };
    }
    build(gallery, swatch.dataset.set, swatch.dataset.mediaId);
    loadAround(gallery, currentIndex(gallery));
  }

  function endPreview(swatch) {
    var card = swatch.closest('.grid-product');
    var gallery = card && card.querySelector('[data-card-gallery]');
    if (!gallery || !gallery._restore) {
      return;
    }

    var restore = gallery._restore;
    gallery._restore = null;
    build(gallery, restore.set, restore.mediaId);
  }

  function updateSwatchArrows(swatches) {
    var swatchTrack = swatches.querySelector('[data-card-swatches-track]');
    var prev = swatches.querySelector('[data-card-swatches-prev]');
    var next = swatches.querySelector('[data-card-swatches-next]');
    if (!swatchTrack || !prev || !next) {
      return;
    }

    prev.disabled = swatchTrack.scrollLeft <= 1;
    next.disabled = swatchTrack.scrollLeft + swatchTrack.clientWidth >= swatchTrack.scrollWidth - 1;
  }

  function pageSwatches(button, direction) {
    var swatches = button.closest('[data-card-swatches]');
    var swatchTrack = swatches.querySelector('[data-card-swatches-track]');
    swatchTrack.scrollBy({ left: direction * swatchTrack.clientWidth, behavior: scrollBehavior() });
  }

  document.addEventListener('click', function(evt) {
    var target = evt.target.closest('[data-card-gallery-prev], [data-card-gallery-next], [data-card-swatch], [data-card-swatches-prev], [data-card-swatches-next]');
    if (!target) {
      return;
    }
    evt.preventDefault();

    if (target.hasAttribute('data-card-swatch')) {
      selectSwatch(target);
    } else if (target.hasAttribute('data-card-swatches-prev')) {
      pageSwatches(target, -1);
    } else if (target.hasAttribute('data-card-swatches-next')) {
      pageSwatches(target, 1);
    } else {
      go(target.closest('[data-card-gallery]'), target.hasAttribute('data-card-gallery-prev') ? -1 : 1);
    }
  });

  // Mouse only: a tap fires pointerover just before its click.
  document.addEventListener('pointerover', function(evt) {
    var swatch = evt.pointerType === 'mouse' && evt.target.closest && evt.target.closest('[data-card-swatch]');
    if (swatch && !swatch.contains(evt.relatedTarget)) {
      previewSwatch(swatch);
    }
  });
  document.addEventListener('pointerout', function(evt) {
    var swatch = evt.pointerType === 'mouse' && evt.target.closest && evt.target.closest('[data-card-swatch]');
    if (swatch && !swatch.contains(evt.relatedTarget)) {
      endPreview(swatch);
    }
  });

  // Hovering or touching the image warms up the neighbouring images.
  function warmUp(evt) {
    var gallery = evt.target.closest && evt.target.closest('[data-card-gallery]');
    if (gallery && !gallery._warm) {
      gallery._warm = true;
      ensureBuilt(gallery);
      if (slideCount(gallery) > 1) {
        loadAround(gallery, currentIndex(gallery));
      }
    }
  }
  document.addEventListener('pointerover', warmUp);
  document.addEventListener('focusin', warmUp);
  document.addEventListener('touchstart', warmUp, { passive: true });

  // Scroll doesn't bubble, so listen in the capture phase.
  var scrollFrame = null;
  document.addEventListener('scroll', function(evt) {
    var target = evt.target;
    if (!target.matches) {
      return;
    }

    if (target.matches('[data-card-swatches-track]')) {
      updateSwatchArrows(target.closest('[data-card-swatches]'));
    } else if (target.matches('[data-card-slides]')) {
      var gallery = target.closest('[data-card-gallery]');
      target.classList.remove('is-settled');
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(function() {
        loadAround(gallery, currentIndex(gallery));
        updateDots(gallery);
      });
      clearTimeout(target._settleTimer);
      target._settleTimer = setTimeout(function() {
        settle(gallery);
      }, 150);
    }
  }, true);

  // Build the slide track ahead of time so the first swipe on touch screens
  // has somewhere to go. Building only adds empty <img>s.
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        ensureBuilt(entry.target);
      }
    });
  }, { rootMargin: '200px 0px' }) : null;

  function observe() {
    document.querySelectorAll('[data-card-gallery]').forEach(function(gallery) {
      if (observer && !gallery._observed) {
        gallery._observed = true;
        observer.observe(gallery);
      }
    });
    document.querySelectorAll('[data-card-swatches]').forEach(function(swatches) {
      updateSwatchArrows(swatches);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
  document.addEventListener('collection:reloaded', observe);
})();
